const CONCEPTOS_SALDO = [
  { clave: 'vacaciones', etiqueta: 'Días de vacaciones disponibles' },
  { clave: 'cuatrimestre', etiqueta: 'Días extraordinarios disponibles' },
  { clave: 'dias_economicos', etiqueta: 'Días económicos disponibles' },
  { clave: 'anios_servicio', etiqueta: 'Días por años de servicio disponibles' },
]

export function periodoTieneSaldo (periodo) {
  return Boolean(periodo) && Number(periodo.dias_asignados) > 0
}

export function obtenerDiasDisponiblesPeriodo (periodo) {
  if (!periodoTieneSaldo(periodo)) {
    return null
  }
  return Number(periodo.dias_disponibles) || 0
}

/**
 * Resumen por concepto: solo incluye tipos con periodo activo y registro en saldos_periodo_permiso.
 */
export function obtenerSaldosPorConcepto (tipos, periodos) {
  const listaTipos = Array.isArray(tipos) ? tipos : []
  const listaPeriodos = Array.isArray(periodos) ? periodos : []
  const resultados = []

  CONCEPTOS_SALDO.forEach((concepto) => {
    const tipo = listaTipos.find((item) => item.clave === concepto.clave)
    if (!tipo) {
      return
    }

    const periodosConSaldo = listaPeriodos.filter((periodo) => {
      if (Number(periodo.id_tipo_permiso) !== Number(tipo.id)) {
        return false
      }
      return periodoTieneSaldo(periodo)
    })

    if (!periodosConSaldo.length) {
      return
    }

    const dias = periodosConSaldo.reduce(
      (total, periodo) => total + (Number(periodo.dias_disponibles) || 0),
      0
    )

    resultados.push({
      clave: concepto.clave,
      etiqueta: concepto.etiqueta,
      dias,
    })
  })

  return resultados
}
